import helper from './helper'

const urlPrefix = '/heat-workouts'

export default {
  getByEvent(id) {
    return helper.get(`${urlPrefix}/event/${id}`)
  },
  get(id) {
    return helper.get(`${urlPrefix}/${id}`)
  },
  add(item) {
    return helper.post(`${urlPrefix}`, item)
  },
  update(item) {
    return helper.put(`${urlPrefix}/${item._id}`, item)
  },
  remove(id) {
    return helper.delete(`${urlPrefix}/${id}`)
  }
}
